import React, { FunctionComponent, ReactElement } from "react";
import { Link } from "@Types/cart";
import "./style.scss";

interface Props {
  additionalInfo?: string;
  description: string;
  link?: Link;
  logos: string[];
  title: string;
}

const CartFooterItem: FunctionComponent<Props> = ({
  logos,
  title,
  description,
  additionalInfo,
  link,
}): ReactElement => {
  return (
    <div className="CartFooterItem">
      <h3 className="CartFooterItem-header">{title}</h3>
      <div className="CartFooterItem-content">
        <div className="CartFooterItem-logos">
          {logos.map((logo, i) => {
            return (
              <img
                className="CartFooterItem-logos-image"
                src={logo}
                alt="logo"
                key={`CartFooterItem-logos_${logo}_${i}`}
              />
            );
          })}
        </div>
        <p className="CartFooterItem-content-info">{description}</p>
        {additionalInfo && <p className="CartFooterItem-content-info">{additionalInfo}</p>}
        {link && (
          <a
            className="CartFooterItem-content-link"
            href={link.href}
            target="_blank"
            rel="noopener noreferrer"
          >
            {link.text}
          </a>
        )}
      </div>
    </div>
  );
};

export default CartFooterItem;
